import React,{useEffect,useState} from "react";
import {Button,Table,Tag,Typography,Alert,Space,Grid} from "antd";
import {ReloadOutlined,DownloadOutlined} from "@ant-design/icons";
import axios from "axios";
import {API_BASE} from "./components/ledger/LedgerResponsive";

const {Title,Text}=Typography;
export default function ReportDownloads(){
 const screens=Grid.useBreakpoint(),isMobile=!screens.md;
 const [rows,setRows]=useState([]),[loading,setLoading]=useState(false),[error,setError]=useState("");
 const [,setClock]=useState(0);
 const load=async()=>{setLoading(true);setError("");try{
   const r=await axios.get(`${API_BASE}/report_downloads_list.php`);
   setRows(r.data?.reports||[]);
 }catch(e){setError(e?.response?.data?.message||"Could not load report downloads.");}finally{setLoading(false);}};
 useEffect(()=>{load();},[]);
 useEffect(()=>{const id=setInterval(()=>setClock(v=>v+1),1000);return()=>clearInterval(id);},[]);
 const parseTime=(v)=>{if(!v)return null;const d=new Date(String(v).replace(" ","T"));return Number.isNaN(d.getTime())?null:d;};
 const elapsed=(r)=>{
   if(r.elapsed_text)return r.elapsed_text;
   const start=parseTime(r.created_at);if(!start)return "—";
   const completed=parseTime(r.completed_at);
   const end=(r.status==="ready"&&completed)?completed:new Date();
   const sec=Math.max(0,Math.floor((end-start)/1000));
   const h=Math.floor(sec/3600),m=Math.floor((sec%3600)/60),ss=sec%60;
   return h>0?`${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(ss).padStart(2,"0")}`:`${String(m).padStart(2,"0")}:${String(ss).padStart(2,"0")} Min.`;
 };
 const status=(r)=>{
   if(r.status==="ready") return <Tag color="green">Ready</Tag>;
   if(r.status==="failed") return <Tag color="red">Failed</Tag>;
   if(r.status==="retrying") return <Tag color="orange">Retrying</Tag>;
   return <Tag color="blue">{r.status_text||"Preparing"}</Tag>;
 };
 const desktopCols=[
  {title:"Report Name",dataIndex:"report_name",key:"report_name",width:300,ellipsis:true,render:v=><Text strong title={v}>{v}</Text>},
  {title:"Format",dataIndex:"output_format",key:"output_format",width:78,render:v=><Tag>{String(v||"pdf").toUpperCase()}</Tag>},
  {title:"Ordered On",dataIndex:"created_at",key:"created_at",width:160},
  {title:"Time Elapsed",key:"elapsed",width:120,render:(_,r)=><Text>{elapsed(r)}</Text>},
  {title:"Status",key:"status",width:105,render:(_,r)=>status(r)},
  {title:"Download",key:"download",width:125,render:(_,r)=>r.status==="ready"&&r.download_token?
    <Button type="primary" size="small" icon={<DownloadOutlined/>}
      onClick={()=>window.location.assign(`${API_BASE}/report_download.php?job_id=${encodeURIComponent(r.job_id)}&download_token=${encodeURIComponent(r.download_token)}`)}>
      Download
    </Button>:<Text type="secondary">Preparing</Text>}
 ];
 const mobileCols=[{...desktopCols[0],width:125},{...desktopCols[3],width:82,title:"Elapsed"},{...desktopCols[4],width:72},{...desktopCols[5],width:96}]; const cols=isMobile?mobileCols:desktopCols;
 return <div style={{padding:24}}>
   <Space style={{width:"100%",justifyContent:"space-between",marginBottom:16}}>
    <div><Title level={3} style={{margin:0}}>Report Downloads</Title>
    <Text type="secondary">Ready reports remain available for 24 hours after preparation.</Text></div>
    <Button icon={<ReloadOutlined/>} onClick={load} loading={loading}>Refresh</Button>
   </Space>
   {error&&<Alert type="error" message={error} showIcon style={{marginBottom:14}}/>}
   <Table rowKey="job_id" columns={cols} dataSource={rows} loading={loading} pagination={{pageSize:20}} scroll={isMobile?undefined:{x:900}} tableLayout="fixed" className={isMobile?"kg-mobile-nowrap-table":""}/>
 </div>;
}